export const handleContactSubjectChange = (sender: any) => {
	var subjectContent = document.getElementById('subject_content') as HTMLInputElement;

	if (typeof (sender) !== typeof (undefined) &&
		sender != null &&
		typeof (sender.options) !== typeof (undefined) &&
		sender.options != null &&
		typeof (sender.selectedIndex) !== typeof (undefined) &&
		sender.selectedIndex != null &&
		typeof (subjectContent) !== typeof (undefined) &&
		subjectContent != null) {
		subjectContent.value = sender.options[sender.selectedIndex].text;
	}

	$("#c-contact__subjet-text").slideDown();
}

(window as any).handleContactSubjectChange = handleContactSubjectChange;
